import { render, staticRenderFns } from "./ApprovalRequestModal.vue?vue&type=template&id=5e2c389f"
import script from "./ApprovalRequestModal.vue?vue&type=script&lang=ts"
export * from "./ApprovalRequestModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports